module.exports = __webpack_public_path__ + "img/loading-white.d40c80e6.svg";